import { typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TitleText = styled.div`
  ${typographyV2.bodyMd}
`;

export const SubtitleSmall = styled.div`
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const BodySmall = styled.div`
  ${typographyV2.bodySm};
`;
